import { closeAllDropdowns } from '@/view/shared/Dropdown';
import type { ModalProps } from '@/view/shared/Modal/Modal.props';
import { Modal as HeroModal } from '@heroui/react';
import { useEffect } from 'react';

export function Modal({
  isOpen,
  setIsOpen,
  title,
  icon,
  children,
  className = '',
  size = 'lg',
  backdropVariant = 'blur',
  isDismissable = true,
}: Readonly<ModalProps>) {
  useEffect(() => {
    if (isOpen) closeAllDropdowns();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <HeroModal.Backdrop
      variant={backdropVariant}
      defaultOpen
      isDismissable={isDismissable}
      onOpenChange={(open) => {
        if (!open) setIsOpen(null);
      }}
    >
      <HeroModal.Container size={size}>
        <HeroModal.Dialog className={className} {...(title ? { 'aria-label': title } : {})}>
          <HeroModal.CloseTrigger />
          {title && (
            <HeroModal.Header>
              <HeroModal.Heading>
                {icon ? (
                  <span className="flex items-center gap-2">
                    {icon}
                    {title}
                  </span>
                ) : (
                  title
                )}
              </HeroModal.Heading>
            </HeroModal.Header>
          )}
          <HeroModal.Body className="px-2">{children}</HeroModal.Body>
        </HeroModal.Dialog>
      </HeroModal.Container>
    </HeroModal.Backdrop>
  );
}
